import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "loginContainer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = { class: "formContainer p-5 position-relative" }
const _hoisted_4 = { class: "text-center mt-3" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        type: "h2",
        localizedKey: "Domain Login",
        text: "Domain Login",
        class: "text-center white"
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Write your email to login with the domain of your company",
          text: "Write your email to login with the domain of your company"
        })
      ]),
      (!_ctx.done)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "mt-5",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_field, {
              type: "email",
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
              placeholderKey: "Email",
              placeholderValue: "Email",
              labelKey: "Email",
              labelValue: "Email"
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary text-center justify-content-center w-100 mt-4",
              disabled: _ctx.disabled
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Login",
                text: "Login"
              })
            ], 8, _hoisted_5)
          ], 32))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_localized_text, {
              localizedKey: "Check your email to complete login",
              text: "Check your email to complete login"
            })
          ])),
      _hoisted_7,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary text-center justify-content-center w-100",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.back()))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Back",
          text: "Back"
        })
      ])
    ])
  ]))
}